var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('PageHeader',{attrs:{"title":"Manage Units","icon":"emoji_symbols"}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","pr-3":""}},[_c('unitDetailManage')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pl-3":""}},[_c('unitGroupManage')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }